(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CustomDocumentsSettingsController', customDocumentsSettingsController);

  customDocumentsSettingsController.$inject = ['$http', '$state', 'AuthenticationService', '$rootScope', 'CompanyService', 'NotificationService'];

  function customDocumentsSettingsController ($http, $state, AuthenticationService, $rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.customDocumentsSettings');

    var vmCustomDocumentsCtrl = this;
    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmCustomDocumentsCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmCustomDocumentsCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmCustomDocumentsCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
